
    <div
      *ngIf="useV3Messaging$ | async; else legacyMessaging"
      style="height: 100%"
    >
      <!-- V3 Messaging Component -->
      <portal-messaging-page></portal-messaging-page>
    </div>

    <ng-template #legacyMessaging>
      <!-- Legacy Messaging Component -->
      <portal-conversation-component></portal-conversation-component>
    </ng-template>
  